module.exports = __webpack_public_path__ + "static/img/login-bg.312ea53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-bg.png
// module id = 1401
// module chunks = 1